import React from "react";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./ButtonWithDropdown.scss";

function ButtonWithDropdown({
  label,
  onClick,
  onDropdownClick,
  variant = "contained",
  color = "secondary",
  size = "medium",
  isDisabled = false,
  className = "",
}) {
  const getButtonClass = () => {
    const baseClass = "button-with-dropdown";
    const variantClass = `${baseClass}--${variant}`;
    const colorClass = `${baseClass}--${color}`;
    const sizeClass = `${baseClass}--${size}`;
    const disabledClass = isDisabled ? `${baseClass}--disabled` : "";

    return `${baseClass} ${variantClass} ${colorClass} ${sizeClass} ${disabledClass} ${className}`;
  };

  return (
    <div className={getButtonClass()}>
      <button className="button-with-dropdown__main" onClick={onClick} disabled={isDisabled} type="button">
        {label}
      </button>
      <button
        className="button-with-dropdown__dropdown"
        onClick={onDropdownClick}
        disabled={isDisabled}
        type="button"
        aria-label="Open menu"
      >
        <ExpandMoreIcon fontSize="small" />
      </button>
    </div>
  );
}

ButtonWithDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onDropdownClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  color: PropTypes.oneOf(["primary", "secondary", "error", "success", "warning"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
};

ButtonWithDropdown.defaultProps = {
  variant: "contained",
  color: "secondary",
  size: "medium",
  isDisabled: false,
  className: "",
};

export default ButtonWithDropdown;
